<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useProfileStore } from '@/presentation/stores/profile/profile.ts'
import { useUserMenu } from '@/presentation/composables/navigation/useUserMenu.ts'
import { default as PButton } from 'primevue/button'
import { default as PAvatar } from 'primevue/avatar'
import { default as PMenu } from 'primevue/menu'
import largeLogoUrl from '@/assets/images/logo-naboo-bleu.svg'
import smallLogoUrl from '@/assets/images/logo-naboo-bleu-small.svg'

// Props
defineProps<{
  isFullyOpened: boolean
}>()

// Store refs
const { getAvatar, getFullName, getFirstNameInitial } = storeToRefs(useProfileStore())

// User menu
const { menuAvatar, userMenuItems, toggleUserMenu } = useUserMenu()
</script>

<template>
  <div class="sticky top-0 z-20 px-6 pt-8">
    <!-- Logo -->
    <img
      :src="isFullyOpened ? largeLogoUrl : smallLogoUrl"
      :class="isFullyOpened ? 'h-3rem block w-fit m-auto' : 'max-w-3rem block'"
      :alt="isFullyOpened ? 'Logo naboo' : 'Logo naboo small'"
    />

    <!-- Profil -->
    <p-button
      @click="toggleUserMenu"
      aria-haspopup="true"
      aria-controls="overlay_menu"
      text
      class="my-8 w-full border-0 p-0"
      :class="isFullyOpened ? 'justify-content-start' : 'justify-content-center'"
    >
      <p-avatar v-if="getAvatar" :image="getAvatar" shape="circle" v-tooltip.right="!isFullyOpened ? getFullName : undefined" />
      <p-avatar v-else :label="getFirstNameInitial?.toLocaleUpperCase()" shape="circle" v-tooltip.right="!isFullyOpened ? getFullName : undefined" />
      <span
        v-if="isFullyOpened"
        class="ml-2 max-w-40 flex-1 overflow-hidden text-left text-ellipsis whitespace-nowrap uppercase"
        data-maskable
        :title="getFullName"
      >
        {{ getFullName }}
      </span>
      <i v-if="isFullyOpened" class="pi pi-chevron-down ml-auto"></i>
    </p-button>
    <p-menu ref="menuAvatar" id="overlay_menu" :model="userMenuItems" :popup="true" />
  </div>
</template>
